// import { getCookieLanguageCode, getCookieCountryCode, iPhone } from '~/utils/utils'
// import { getCookieLanguageCode, getCookieCountryCode, getRiskModule } from '~/utils/utils'
import {
  getCookieLanguageCode,
  getCookieCountryCode,
  iPhone
} from '~/utils/utils'
import menu from '~/static/json/menu.json'
import index from '~/static/json/index.json' // 引入首页配置
export default async ({
  isHMR,
  app,
  $api,
  route,
  store,
  req,
  redirect,
  res
}) => {
  if (isHMR) return false // 热更新状态下，不执行后续操作
  if (!req) return
  // 设置域名后缀
  // let myDomin = req && req.headers.host.split('.')
  const host = req.headers.host.includes('aws')
    ? req.headers.host.replace('aws.', '')
    : req.headers.host // 获取域名不带www前缀
  // console.log(process.server, 8887)
  if (route.path.includes('/HealthCheck/Get')) {
    // 屏蔽健康检查
    res.statusCode = 200
    return
  }
  const hostS = `https://${host}${route.fullPath}` // 获取主域名带当前页面地址
  store.commit('setHostend', host)
  store.commit('setAllhost', hostS)
  // myDomin = myDomin[myDomin.length - 1]
  if (host.includes(':')) {
    // 取主域名
    // myDomin = myDomin.split(':')[0]
  }
  const routeLang = route.params.lang && route.params.lang.toLowerCase()
  // if (myDomin == 'cc') { // 后缀为cc自动跳转到越南语
  //   store.commit('setLangCode', { lang: 'vi', hostS: host }) // 获取语言
  //   if (routeLang != 'vi') {
  //     return redirect(302, `/vi/${route.fullPath.split('/').slice(2).join('/')}`)
  //   }
  // }
  try {
    const ENVIRONMENT = process?.env?.ENVIRONMENT || ''
    store.commit('setNodeEnv', ENVIRONMENT) // 获取环境变量
  } catch (err112) {
    console.log(err112, 113)
  }
  // const forwardedIp = req.headers['x-forwarded-for'] ? req.headers['x-forwarded-for'].split(',')[0] : '114.114.114.114' // 后期取客户端ip---缺
  // const forwardedIp = await app.$axios.get('https://exportedbase.fx696.com/ip', { headers: { 'Content-type': 'application/x-www-form-urlencoded', xhrFields: { withCredentials: true }, crossDomain: true } })
  const forwardedIp = await app.$axios.get('https://exportedbase.fx696.com/ip') // 获取用户ip
  console.log(forwardedIp.data.result.ip, 777)
  const userIp = await app.$axios
    .get(
      `http://ipinversion.fxeyeinterface.com/api/v1/getipgeo?ip=${forwardedIp.data.result.ip}`
    )
    .catch((err) => {
      // 用户ip语言
      console.log('GetMyCountry', 99, err)
    })
  const uip =
    userIp && userIp.data && userIp.data.data && userIp.data.data.ip
      ? userIp.data.data.ip
      : forwardedIp
  store.commit('getIp', uip) // 获取用户ip
  const myCountry =
    userIp && userIp.data && userIp.data.data && userIp.data.data.country_code
      ? userIp.data.data.country_code
      : 'cn'
  let cookieHost = host
    ? host.includes('9118')
      ? host.split(':')[0]
      : host.includes('443')
        ? host.split(':')[0].substr(host.indexOf('.'))
        : host.substr(host.indexOf('.'))
    : '.wikifx.com'
  store.commit('setPath', route.fullPath.split('/').splice(2).join('/')) // 获取语言
  cookieHost = cookieHost.includes('aws')
    ? cookieHost.replace('aws.', '')
    : cookieHost
  store.commit('setcookieHost', cookieHost) // 处理好存cookie需要的路径域名
  const suffix = cookieHost?.split('.')?.[2] || 'com'
  store.commit('setsuffix', suffix)
  // const newUrl = ['fxeye688', 'fxeye', 'fxeye2017', 'fxeye777', 'fxeye110', 'fxeye123']
  const urlBool = cookieHost ? cookieHost.split('.')[1] : cookieHost
  let country = await getCookieCountryCode(req, app) // 获取设置国家cookie

  // fxeye机器人检测
  // const curHost = store.state.host // 'fxeye'
  // if (curHost.includes('fxeye688') || curHost.includes('fxeye2017')) {
  //   const PassCheckAuto = app.$cookies.get('PassCheckAuto')
  //   if ((!PassCheckAuto || PassCheckAuto != '1') && !route.path.toLowerCase().includes('checkrobot.html')) {
  //     store.commit('setMyCountry', { myCountry, hostS: host }) // 存储用户所在的国家
  //     store.commit('setLangCode', { lang: 'zh-cn', hostS: host }) // 获取 语言
  //     store.commit('setCountryCode', { country: 'cn', hostS: host }) // 获取国家
  //     let backurl = `/zh-cn/${route.fullPath.split('/').slice(2).join('/')}`
  //     backurl = decodeURIComponent(backurl).replace('/zh-cn/zh-cn', '/zh-cn')
  //     return redirect(302, `/zh-cn/checkrobot.html?backurl=${backurl}`)
  //   }
  // }
  if (store.state.isWiki == '2' || store.state.isWiki == '3' || store.state.isWiki == '4') { // 判断处理特殊域名
    store.commit('setHost', {
      host: urlBool,
      bool: true
    })
    if ((store.state.isWiki == '2' || store.state.isWiki == '4') && (!hostS.includes('/zh-cn') || (app.$cookies.get('CountryCode') != 'cn'))) {
      // console.log(123, !hostS.includes('zh-cn'), (app.$cookies.get('CountryCode') != 'cn'))
      // store.commit('setMyCountry', { myCountry, hostS: host }) // 存储用户所在的国家
      // store.commit('setLangCode', { lang: 'zh-cn', hostS: host }) // 获取 语言
      // store.commit('setCountryCode', { country: 'cn', hostS: host }) // 获取国家
      country = 'cn'
      app.i18n.locale = 'zh-cn'
      if (!hostS.includes('/zh-cn')) return redirect(302, `/zh-cn/${route.fullPath.split('/').slice(2).join('/')}`)
    }
  }
  if (routeLang == 'zh-tw' || routeLang == 'zh-hk')
    return redirect(301, `/zh/${route.fullPath.split('/').slice(2).join('/')}`) // 台湾或者香港跳转到zh
  if (route.fullPath == `/${routeLang}/survey`)
    return redirect(301, `/${routeLang}/survey/all/1.html`)
  if (!routeLang || !store.state.langList.includes(routeLang)) {
    // 用户没有通过语言直接通过域名访问
    await getCookieLanguageCode(req, app, redirect, store, route) // 设置语言cookie
    return
  }
  store.commit('setMobile', iPhone(req)) // 判断是否移动端

  // 不带.html后缀的各类详情页url,补齐.html
  if (!route.path.includes('.html')) {
    const allDetail =
      '/dealer/,/newsdetail/,/exposure/,/market/,/survey/,/intro/,/class/,/brokers/,/wikishow/'
    const curDetail = route.path.toLowerCase().split('/')
    if (curDetail.length >= 4 && allDetail.includes(curDetail[2])) {
      return redirect(
        302,
        `${
          process.env.NODE_ENV != 'production' &&
          (host.includes('192.168.') || host.includes('localhost'))
            ? 'http'
            : 'https'
        }://${host}${route.fullPath}.html`
      )
    }
  }

  country = country.toLowerCase() == 'gb' ? 'uk' : country
  let countryArr = []
  if (
    routeLang == 'zh-cn' ||
    routeLang == 'zh-tw' ||
    routeLang == 'zh-hk' ||
    routeLang == 'zh'
  ) {
    countryArr = require('~/static/json/areaCodeCN.json')
  } else {
    countryArr = require('~/static/json/areaCodeEn.json')
  }
  let countryInfo = {}
  countryArr.forEach((item) => {
    item.data.forEach((itemS) => {
      if (country.toLowerCase() == itemS.twoCharCode.toLowerCase()) {
        countryInfo = itemS
      }
    })
  })
  // console.log(countryInfo, 888, country)
  // console.log(req.headers['x-forwarded-for'], 11123)
  // console.log(userIp, 8887)
  // 用户登录
  const DJkdikKMG = app.$cookies.get('DJkdikKMG')
  const ViLartidlakd = app.$cookies.get('ViLartidlakd')
  const WsdsfgDGdagYms = app.$cookies.get('WsdsfgDGdagYms')
  const contentcookie = DJkdikKMG || ViLartidlakd || WsdsfgDGdagYms
  // console.log('contentcookie: ', contentcookie)
  let login = null
  if (contentcookie) {
    login = $api.home
      .getUsercookie({
        contentcookie
      })
      .catch(() => {
        console.log('login')
      })
  }

  store.commit('setLangCode', { lang: routeLang, hostS: host }) // 获取语言
  store.commit('setCountryCode', { country, hostS: host }) // 获取国家
  console.log('country: ', country)
  store.commit('setMyCountry', { myCountry, hostS: host }) // 存储用户所在的国家
  store.commit('setInfo', countryInfo) // 获取国家code，国家名称，国家代码，国旗
  store.commit('setuserCountry', countryInfo) // 用户中心获取国家code，国家名称，国家代码，国旗

  // 头部菜单
  const headermenu = $api.list.headermenu().catch(() => {
    console.log('headermenu')
  })
  // 底部联系方式
  const contactinfo = $api.list.contactinfo().catch(() => {
    console.log('contactinfo')
  })

  // 底部国家
  const footcountry = $api.home.country().catch(() => {
    console.log('footcountry')
  })

  // 友情链接
  const linksList = $api.home.getFriendlinks().catch(() => {
    console.log('getFriendlinks')
  })

  // 战略合作
  const partnerList = $api.home.getPartnetlist().catch(() => {
    console.log('partnerList')
  })

  // 直播状态
  const liveroom = $api.home.liveroom({ liveCountStatus: '1' }).catch(() => {
    console.log('liveroom')
  })

  // 屏蔽点位
  const risk = $api.home.riskcontrol({}).catch(() => {
    console.log('riskcontrol')
  })
  // const partnerList = $api.home.partnerList().catch(() => {
  //   console.log('partnerList')
  // })
  // console.log(req.headers.cookie, 9984)
  let pingBi = null
  if (
    store.state.isWiki == '2' ||
    store.state.isWiki == '3' ||
    store.state.isWiki == '4'
  ) {
    // 屏蔽中心
    pingBi = $api.home.getmanybyproj().catch(() => {
      console.log('partnerList')
    })
  }
  return Promise.all([
    login,
    headermenu,
    contactinfo,
    footcountry,
    linksList,
    partnerList,
    pingBi,
    liveroom,
    risk
  ]).then((result) => {
    // 是否是去中文点位配置
    const riskRet = result[8] ? result[8] : {}
    const riskArr = Object.keys(riskRet)
    let riskRemoveZhcn = false
    riskArr.forEach((rit) => {
      if (rit == '351001' && riskRet[rit] == '0') {
        riskRemoveZhcn = true
      }
    })
    // 去中文点位判断[语言跳转]
    if ((routeLang == 'zh-cn' || routeLang == 'zh') && riskRemoveZhcn) {
      redirect(302, `/en/${route.fullPath.split('/').slice(2).join('/')}`)
    }

    // console.log('login: ', store.state.isWiki)
    // console.log(result[7], 666)
    // const menuArr = result[1] ? menu.filter(item => (result[1] && result[1].some(items => items.code == item.code))) : []
    if (
      store.state.isWiki == '2' ||
      store.state.isWiki == '3' ||
      store.state.isWiki == '4'
    ) {
      const pingData = {}
      result[6] &&
        result[6].forEach((item) => {
          // 屏蔽点位
          item.arr = JSON.parse(item.value)
          if (item.point == 15) {
            // 直播-菜单
            pingData.live = {}
            Object.assign(pingData.live, item)
          } else if (item.point == 40) {
            // 天眼云-菜单
            pingData.vps = {}
            Object.assign(pingData.vps, item)
          } else if (item.point == 70) {
            // 首页推流
            pingData.ad = {}
            Object.assign(pingData.ad, item)
          } else if (item.point == 136) {
            // 首页排行榜
            pingData.rank = {}
            Object.assign(pingData.rank, item)
          } else if (item.point == 30) {
            // 首页资讯
            pingData.article = {}
            Object.assign(pingData.article, item)
          } else if (item.point == 20) {
            // ea商城-菜单
            pingData.ea = {}
            Object.assign(pingData.ea, item)
          } else if (item.point == 67) {
            // 交易商详情页-epc
            pingData.epc = {}
            Object.assign(pingData.epc, item)
          } else if (item.point == 68) {
            // 交易商详情页-emc
            pingData.emc = {}
            Object.assign(pingData.emc, item)
          } else if (item.point == 140) {
            // 首页排行榜广告
            pingData.leaderboard = {}
            Object.assign(pingData.leaderboard, item)
          } else if (item.point == 31) {
            // 资讯页面tab
            pingData.listnews = {}
            Object.assign(pingData.listnews, item)
          } else if (item.point == 137) {
            // 排行榜页面
            pingData.boardalllist = {}
            Object.assign(pingData.boardalllist, item)
          } else if (item.point == 145) {
            // 品专搜索广告样式
            pingData.pinzhuan = {}
            Object.assign(pingData.pinzhuan, item)
          } else if (item.point == 130) {
            // 复制网址
            pingData.urlredirect = {}
            Object.assign(pingData.urlredirect, item)
          } else if (item.point == 120) {
            // 风险提示弹框
            pingData.riskwarning = {}
            Object.assign(pingData.riskwarning, item)
          } else if (item.point == 175) { // 首页红点弹框
            pingData.popred = {}
            Object.assign(pingData.popred, item)
          }
        })
      // console.log(pingData, 1111)
      store.commit('setFxeyepoint', pingData)
    }
    // console.log(result[6].data, 666, menu)
    const menuArr = []
    if (result[1]) {
      // 菜单处理
      result[1].forEach((item) => {
      //   if (store.state.isWiki == '1') {
      //     // wikifx显示
      //     const t = menu.filter(items => items.code == item.code)
      //     if (t[0]) menuArr.push(t[0])
      //   } else if (
      //     store.state.isWiki == '2' ||
      //     store.state.isWiki == '3' ||
      //     store.state.isWiki == '4'
      //   ) {
      //     // fxeye显示
      //     const t = menu.filter(items => items.code == item.code)
      //     if (t[0]) {
      //       // console.log(t[0], 123)
      //       if (t[0].code == 'menu_liveroom') {
      //         if (
      //           store.state.fxeyepoint.live &&
      //           store.state.fxeyepoint.live.point == 15 &&
      //           store.state.fxeyepoint.live.value != 'false'
      //         ) {
      //           menuArr.push(t[0])
      //         }
      //       } else if (t[0].code == 'menu_cloud') {
      //         if (
      //           store.state.fxeyepoint.vps &&
      //           store.state.fxeyepoint.vps.point == 40 &&
      //           store.state.fxeyepoint.vps.value != 'false'
      //         ) {
      //           menuArr.push(t[0])
      //         }
      //       } else {
      //         menuArr.push(t[0])
      //       }
      //     }
      //   }
        const t = menu.filter(items => items.code == item.code)
        if (t[0]) menuArr.push(t[0])
      })
    }
    // console.log(menuArr, 999)
    // console.log(result[1], 666)
    const user =
      result[0] && result[0].result && result[0].result.userId
        ? result[0].result
        : {}
    result[3] &&
      result[3].forEach((item) => {
        item.abbr = item.twoCharCode.toLowerCase()
      })

    // 用户真实所在地址
    // let userCountryInfo = {};
    // countryArr.forEach((item) => {
    //   item.data.forEach((itemS) => {
    //     if (myCountry.toLowerCase() == itemS.twoCharCode.toLowerCase()) {
    //       userCountryInfo = itemS;
    //     }
    //   });
    // });

    if (myCountry.toLowerCase() != 'cn' && myCountry.toLowerCase() != 'hk' && country.toLowerCase() != 'cn' && country.toLowerCase() != 'hk') {
      result[3] &&
      result[3].forEach((item) => {
        if (item.code == '344')
          item.name = item.name
            .replace('中国', '')
            .replace('中國', '')
            .replace('China', '')
        if (item.code == '158')
          item.name = item.name
            .replace('中国', '')
            .replace('中國', '')
            .replace('China', '')
      })
    }

    // console.log(userIp.data, 999)
    store.commit('setriskcontrol', result[8] ? result[8] : {}) // 屏蔽点位
    store.commit('setPartnerList', result[5] ? result[5] : []) // 战略合作
    store.commit('setlinkFriend', result[4] ? result[4] : []) // 友情链接
    store.commit('setMenu', menuArr) // 获取菜单数据
    store.commit('setConfigure', index) // 首页配置
    store.commit('setContactinfo', result[2]) // 底部联系方式
    store.commit('setUser', user) // 获取用户登录cookie
    store.commit('setUsercookie', contentcookie) // 获取用户登录cookie
    // store.commit("setuserCountry", userCountryInfo); // 用户中心获取国家code，国家名称，国家代码，国旗
    store.commit('setfootCountry', result[3] ? result[3] : []) // 设置底部国家
    // store.commit('setMyCountry', { myCountry, hostS: host }) // 存储用户所在的国家
    store.commit('setLivestate', result[7] ? result[7] : {}) // 获取直播状态
    app.i18n.locale = routeLang
  })
}
